import { render, staticRenderFns } from "./KBTableDailyContact.vue?vue&type=template&id=ebc9d1ca&"
import script from "./KBTableDailyContact.vue?vue&type=script&lang=js&"
export * from "./KBTableDailyContact.vue?vue&type=script&lang=js&"
import style0 from "./KBTableDailyContact.vue?vue&type=style&index=0&id=ebc9d1ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports